import { Col, Form, Row } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomFormItem from '../../../v2-components/Antd/FormItem';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomInput from '../../../v2-components/Antd/Input';
import CustomLink from '../../../v2-components/Antd/Link';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import useSearchStore from '../../../v2-components/Search/store/useSearchStore';
import { capitalizeFirstLetter } from '../../pharmacy-sliders/handle/capitalize-first-letter.handle';
import useLandingStore from '../store/useLandingStore';
import { Service } from './service';
import { nameAdapter } from '../create/handle/name-adapter.handle';
import './style.scss';

export default function LandingCreatePage() {
	const [activeTabKey1, setActiveTabKey1] = useState('tab1');
	const [form] = Form.useForm();
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [setProducts] = useSearchStore((state) => [state.setProducts]);
	const history = useHistory();
	const [platform, currentPage, status, pageData, mainData, currentSection, setPageData, setMainData, setCurrentSection, setOriginProducts] =
		useLandingStore((state) => [
			state.platform,
			state.currentPage,
			state.status,
			state.pageData,
			state.mainData,
			state.currentSection,
			state.setPageData,
			state.setMainData,
			state.setCurrentSection,
			state.setOriginProducts,
		]);

	const onTab1Change = (key) => {
		setActiveTabKey1(key);
	};

	const tabList = [
		{
			key: 'tab1',
			tab: 'Lista de productos',
		},
		{
			key: 'tab2',
			tab: 'Espacios publicitarios',
		},
	];
	console.log('currentSectionProducts', currentSection);
	const contentList = {
		tab1: (
			<CustomCard
				onClick={() => {
					if (currentSection.length === 0 || !currentSection[0]?.tag) {
						return;
					}
					handleCheckProducts();
					history.push('/landing/create/product-list');
				}}
				style={{ width: '336px', height: '310px', cursor: 'pointer' }}
				title={
					<div>
						<h3>Lista de productos</h3>
						<div>
							<p>{currentSection[0]?.products?.length > 0 ? `${currentSection[0]?.products?.length} productos` : 'Vacio'}</p>
						</div>
					</div>
				}
			>
				<CustomImage
					preview={false}
					src={'https://storage.googleapis.com/tirx-resources-develop/f3767c66-ae62-4355-a84a-6a8b6bdd7cb5.webp'}
					alt="img"
				/>
			</CustomCard>
		),
		tab2: <p>Próximamente espacios publicitarios</p>,
	};

	const handleOnFinish = () => {
		setOpenLoadingModal(true);
		if (currentSection.length > 0) {
			console.log('entro aca');
			const body = { ...form.getFieldsValue(), country: Enviroment.COUNTRY, root_pharmacy: platform, id: currentSection[0]?._id };
			new Service()
				.updateTag(body)
				.then((response) => {
					console.log('response', response);
					if (response.statusCode === 400) {
						setOpenLoadingModal(false);
						return CustomNotification({
							type: 'error',
							message: 'Error',
							description: 'El slug ya se encuentra en uso. Elija otro nombre',
						});
					}
					setOpenLoadingModal(false);
					setPageData(response);
					setMainData({ ...mainData, [`page${currentPage}`]: response });
					setCurrentSection([{ ...currentSection[0], tag: body.tag, editable_name: body.editable_name }]);
				})
				.catch((error) => console.log(error));
		} else {
			console.log('entro aca');
			const body = {
				...form.getFieldsValue(),
				country: Enviroment.COUNTRY,
				root_pharmacy: platform,
				type: pageData[0]?.type,
				page: +currentPage,
				link_name: pageData[0]?.link_name,
				status: status[`page${currentPage}`],
				isPageActive: status[`page${currentPage}`],
				section: 'landing',
			};
			new Service()
				.create(body)
				.then((response) => {
					if (response.statusCode === 400) {
						setOpenLoadingModal(false);
						return CustomNotification({ type: 'error', message: 'Error', description: response.message });
					}
					setOpenLoadingModal(false);
					setPageData([...pageData, response[0]]); //revisar
					setMainData({ ...mainData, [`page${currentPage}`]: [...pageData, response[0]] }); //revisar
					setCurrentSection(response);
				})
				.catch((error) => {
					console.log('error', error);
				});
		}
	};

	const handleCheckProducts = () => {
		if (currentSection[0]?.products?.length > 0) {
			new Service()
				.getProducts(currentSection[0].products.toString())
				.then((response) => {
					console.log('response', response);
					setProducts(response);
					setOriginProducts(response);
				})
				.catch((error) => {
					console.log('error', error);
				});
		} else {
			setProducts([]);
			setOriginProducts([]);
		}
	};

	return (
		<div className="admin-create-landing-detail">
			<h1>{capitalizeFirstLetter('Crear sección')}</h1>
			<CustomLink to={`/landing/detail`}>{`Volver a ${nameAdapter(platform)} / ${pageData[0]?.link_name}`}</CustomLink>
			<CustomCard>
				<Form
					form={form}
					initialValues={{ editable_name: currentSection[0]?.editable_name, tag: currentSection[0]?.tag }}
					onFinish={handleOnFinish}
					className="create-form"
				>
					<h2>Datos de la sección</h2>
					<Row style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Col lg={10}>
							<p>Titulo sección (visible en el margen izquierdo de la web)</p>
							<CustomFormItem name={'editable_name'} rules={'required'}>
								<CustomInput />
							</CustomFormItem>
						</Col>
						<Col lg={10}>
							<p>Slug sección (visible en la web)</p>
							<CustomFormItem name={'tag'} rules={('required', 'alphanumeric')}>
								<CustomInput />
							</CustomFormItem>
							<p>No usar espacios, reemplazar con - (guión medio). Ej: hola-mundo </p>
						</Col>
					</Row>
					<Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<div>
							<p>Para que la página se muestre debes completar los campos superiores y tener una sección activa.</p>
						</div>
						<div style={{ display: 'flex', gap: '10px' }}>
							<CustomButton onClick={() => form.resetFields()}>CANCELAR</CustomButton>
							<CustomButton htmlType="submit">GUARDAR</CustomButton>
						</div>
					</Row>
				</Form>
			</CustomCard>
			<h1 style={{ marginTop: '40px' }}>Seleccionar módulo a editar</h1>
			<CustomCard
				style={{
					width: '100%',
				}}
				tabList={tabList}
				activeTabKey={activeTabKey1}
				onTabChange={onTab1Change}
			>
				{contentList[activeTabKey1]}
			</CustomCard>
			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
